import { array, object, string } from "yup";

export const sendToEmailSchema = object({
  members: array().min(1, "Please select at least one member"),
  subject: string().required("Please add email subject"),
});
